import Button from '@/components/base/Button';

export interface NewOrderRow {
  id: string;
  orderNo: string;
  customer: string;
  customerPhone: string;
  items: string;
  itemsCount: number;
  priority: string;
  amount: string;
  time: string;
  source: string;
}

interface NewOrdersTableProps {
  orders: NewOrderRow[];
  highlightIds?: string[];
  onAccept: (orderNo: string) => void;
  onReject: (orderNo: string) => void;
  onOpenOrder: (orderNo: string) => void;
  onViewAll: () => void;
}

export default function NewOrdersTable({
  orders,
  highlightIds = [],
  onAccept,
  onReject,
  onOpenOrder,
  onViewAll,
}: NewOrdersTableProps) {
  return (
    <section>
      <div className="mb-3 flex items-center justify-between">
        <h2 className="font-semibold text-base text-foreground-950">الطلبات الجديدة</h2>
        <button
          type="button"
          onClick={onViewAll}
          className="flex items-center gap-1 text-[13px] font-medium text-secondary-600 transition-colors hover:text-secondary-700"
        >
          عرض الكل
          <i className="ri-arrow-left-line text-sm" aria-hidden="true"></i>
        </button>
      </div>

      <div className="overflow-hidden rounded-card border border-background-200 bg-white shadow-card">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[900px] border-collapse text-right">
            <thead>
              <tr className="bg-background-50">
                <th className="px-4 py-3 font-semibold text-[12px] text-foreground-500">رقم الطلب</th>
                <th className="px-4 py-3 font-semibold text-[12px] text-foreground-500">العميل</th>
                <th className="px-4 py-3 font-semibold text-[12px] text-foreground-500">القطع</th>
                <th className="px-4 py-3 font-semibold text-[12px] text-foreground-500">الأولوية</th>
                <th className="px-4 py-3 font-semibold text-[12px] text-foreground-500">المبلغ</th>
                <th className="px-4 py-3 font-semibold text-[12px] text-foreground-500">الوقت</th>
                <th className="px-4 py-3 font-semibold text-[12px] text-foreground-500">إجراء</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, index) => {
                const isNew = highlightIds.includes(order.id);
                return (
                <tr
                  key={order.id}
                  className={[
                    'border-t border-background-100 transition-colors hover:bg-background-100',
                    isNew ? 'animate-row-flash' : '',
                    index % 2 === 1 ? 'bg-background-50/60' : 'bg-white',
                  ].join(' ')}
                >
                  <td className="px-4 py-3.5">
                    <button
                      type="button"
                      onClick={() => onOpenOrder(order.orderNo)}
                      className="font-semibold text-[13px] text-secondary-600 transition-colors hover:text-secondary-700"
                    >
                      {order.orderNo}
                    </button>
                    <span className="mt-0.5 block text-[11px] text-foreground-400">
                      {order.source}
                    </span>
                  </td>
                  <td className="px-4 py-3.5">
                    <span className="block text-[13px] font-medium text-foreground-900">
                      {order.customer}
                    </span>
                    <span className="mt-0.5 block text-[11px] text-foreground-400" dir="ltr">
                      {order.customerPhone}
                    </span>
                  </td>
                  <td className="px-4 py-3.5">
                    <span className="block max-w-[190px] truncate text-[13px] text-foreground-700">
                      {order.items}
                    </span>
                    <span className="mt-0.5 block text-[11px] text-foreground-400">
                      {order.itemsCount} قطعة
                    </span>
                  </td>
                  <td className="px-4 py-3.5">
                    {order.priority === 'urgent' ? (
                      <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-[12px] font-medium text-foreground-950">
                        <i className="ri-flashlight-fill text-[11px]" aria-hidden="true"></i>
                        مستعجل
                      </span>
                    ) : (
                      <span className="inline-flex items-center rounded-full bg-secondary-200 px-2.5 py-1 text-[12px] font-medium text-secondary-700">
                        عادي
                      </span>
                    )}
                  </td>
                  <td className="px-4 py-3.5 text-[13px] font-semibold text-foreground-950">
                    {order.amount}
                  </td>
                  <td className="px-4 py-3.5 text-[12px] text-foreground-500">{order.time}</td>
                  <td className="px-4 py-3.5">
                    <div className="flex items-center gap-2">
                      <Button size="sm" variant="cta" onClick={() => onAccept(order.orderNo)}>
                        قبول
                      </Button>
                      <Button size="sm" variant="danger" onClick={() => onReject(order.orderNo)}>
                        رفض
                      </Button>
                    </div>
                  </td>
                </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}